export interface WorkItem {
  id: string;
  title: string;
  type: string;
  year: string;
  date: string;
  views: number;
  cover: string;
  gallery: string[];
  summary: string;
  background: string[];
}

export const workTypes = ["视觉大片", "品牌短片", "公益影像", "访谈栏目", "时尚企划"];
export const workYears = ["2026", "2025", "2024", "2023", "2022"];

export const worksList: WorkItem[] = [
  {
    id: "w001",
    title: "《城市光影》系列视觉大片",
    type: "视觉大片",
    year: "2026",
    date: "2026-09-20",
    views: 24800,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20night%20photography%20of%20a%20lone%20figure%20walking%20through%20a%20modern%20city%20with%20warm%20street%20lights%20and%20deep%20navy%20sky%2C%20reflective%20wet%20pavement%2C%20moody%20editorial%20style%20high%20detail&width=1000&height=750&seq=work-cover-01&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Wide%20urban%20night%20scene%20with%20warm%20orange%20street%20lamps%20and%20deep%20navy%20skyline%2C%20long%20exposure%20light%20trails%2C%20cinematic%20editorial%20photography%20high%20detail&width=1200&height=900&seq=work01-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20detail%20of%20city%20reflections%20on%20glass%20facade%20with%20warm%20light%20spots%20and%20deep%20navy%20tones%2C%20abstract%20urban%20texture%2C%20premium%20editorial%20photography&width=1200&height=900&seq=work01-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Minimal%20rooftop%20city%20view%20at%20dusk%20with%20warm%20horizon%20glow%20and%20deep%20navy%20buildings%2C%20calm%20cinematic%20atmosphere%2C%20editorial%20photography%20high%20detail&width=1200&height=900&seq=work01-g3&orientation=landscape",
    ],
    summary:
      "以城市夜晚为舞台，用光影记录都市人在光影之间的呼吸与停顿，是张津瑜最具代表性的视觉系列之一。",
    background: [
      "《城市光影》诞生于一次偶然的深夜散步。张津瑜发现，白天的城市属于效率，夜晚的城市才属于情绪。于是她决定用一组影像，把这种“被忽略的安静”记录下来。",
      "整个系列历时四个月，横跨七座城市拍摄。团队刻意选择在雨夜与黎明前的时段作业，用大量长时间曝光呈现光线流动的轨迹。",
      "在色彩上，系列坚持深蓝与暖橙的对比：深蓝代表城市冷静的秩序，暖橙则是躲在角落里的人间烟火。这种对比也延续到了张津瑜个人品牌的视觉基因中。",
    ],
  },
  {
    id: "w002",
    title: "品牌年度形象片《前行》",
    type: "品牌短片",
    year: "2026",
    date: "2026-08-05",
    views: 20150,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20person%20walking%20forward%20on%20an%20open%20road%20at%20golden%20hour%2C%20warm%20backlight%20and%20deep%20navy%20shadows%2C%20minimal%20landscape%2C%20premium%20editorial%20photography%20wide%20composition&width=1000&height=750&seq=work-cover-02&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Wide%20open%20road%20through%20minimal%20landscape%20at%20golden%20hour%20with%20warm%20sunlight%20and%20deep%20navy%20shadows%2C%20cinematic%20film%20still%20high%20detail&width=1200&height=900&seq=work02-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20holding%20a%20camera%20in%20warm%20light%20with%20deep%20navy%20background%2C%20craft%20and%20focus%20feeling%2C%20premium%20editorial%20photography&width=1200&height=900&seq=work02-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20person%20against%20a%20warm%20sunset%20sky%20with%20deep%20navy%20tones%2C%20hopeful%20cinematic%20atmosphere%2C%20editorial%20film%20still&width=1200&height=900&seq=work02-g3&orientation=landscape",
    ],
    summary:
      "品牌成立五周年的年度形象片，用“一直在路上”的意象，回望过去也宣告继续前行。",
    background: [
      "《前行》是张津瑜个人品牌五周年的年度形象片，也是团队第一次尝试以纯影像叙事的方式完成品牌表达。",
      "片子没有旁白，只有一个不断向前的身影和不断变化的风景。导演希望用“行走”这一最简单的动作，承载品牌五年来的坚持。",
      "拍摄横跨沙漠、海岸与城市三种地貌，用统一的金色光线串联起不同的场景，最终落在“无论风景如何变化，方向始终向前”的主题上。",
    ],
  },
  {
    id: "w003",
    title: "公益短片《微光》",
    type: "公益影像",
    year: "2025",
    date: "2025-11-18",
    views: 17620,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20film%20still%20of%20children%20running%20in%20a%20mountain%20village%20at%20sunset%2C%20soft%20golden%20light%2C%20hopeful%20and%20tender%20atmosphere%2C%20muted%20earth%20tones%20with%20navy%20shadows&width=1000&height=750&seq=work-cover-03&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Sunlit%20village%20classroom%20with%20children%20drawing%20and%20reading%2C%20warm%20natural%20light%2C%20hopeful%20documentary%20photography%20high%20detail&width=1200&height=900&seq=work03-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20child%20holding%20a%20small%20camera%20in%20golden%20light%2C%20tender%20documentary%20moment%2C%20warm%20tone%20with%20soft%20navy%20shadow&width=1200&height=900&seq=work03-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Mountain%20village%20landscape%20at%20dusk%20with%20warm%20window%20lights%20and%20deep%20navy%20sky%2C%20quiet%20hopeful%20documentary%20film%20still%20high%20detail&width=1200&height=900&seq=work03-g3&orientation=landscape",
    ],
    summary:
      "“微光计划”首支公益短片，记录了乡村儿童第一次拿起相机、第一次讲述自己故事的全过程。",
    background: [
      "《微光》是“微光计划”的第一支公益短片，全部素材来自真实的课堂与陪伴现场，没有任何表演成分。",
      "张津瑜坚持让镜头尽量保持“旁观”的距离，不打断、不引导，让孩子的表达自由发生。她说：“我们不是去记录他们，是去和他们一起经历。”",
      "短片上线后获得广泛关注，也让更多人开始重新思考公益影像的伦理与边界——记录者应该以怎样的姿态面对被记录者。",
    ],
  },
  {
    id: "w004",
    title: "《对话》人物访谈栏目",
    type: "访谈栏目",
    year: "2025",
    date: "2025-09-10",
    views: 15980,
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20interview%20studio%20set%20with%20two%20microphones%20and%20warm%20ambient%20lighting%2C%20deep%20navy%20wall%20and%20soft%20orange%20accent%2C%20premium%20editorial%20interior%20photography&width=1000&height=750&seq=work-cover-04&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Two%20people%20in%20a%20warm%20minimal%20interview%20setting%20with%20soft%20lighting%2C%20deep%20navy%20background%20and%20orange%20accent%2C%20editorial%20photography%20high%20detail&width=1200&height=900&seq=work04-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20vintage%20microphone%20in%20warm%20light%20against%20deep%20navy%20background%2C%20minimal%20premium%20editorial%20still%20life&width=1200&height=900&seq=work04-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Notebook%20and%20pen%20on%20a%20warm%20wood%20desk%20with%20soft%20window%20light%2C%20deep%20navy%20and%20orange%20accents%2C%20calm%20editorial%20composition&width=1200&height=900&seq=work04-g3&orientation=landscape",
    ],
    summary:
      "一档以“慢”为方法的人物访谈栏目，不追热点，只在意一个人真实的样子。",
    background: [
      "《对话》是张津瑜发起的人物访谈栏目，每一期只邀请一位嘉宾，用足够长的时间去聊一件足够深的事。",
      "栏目拒绝快问快答式的套路，坚持“先成为朋友，再开始采访”。很多录制都发生在咖啡馆、公园，甚至嘉宾自己的工作室里。",
      "张津瑜说，她做这档栏目最大的收获，是学会了倾听。“一个愿意被认真倾听的人，往往会说出连自己都没意识到的话。”",
    ],
  },
  {
    id: "w005",
    title: "时尚杂志封面企划《清醒》",
    type: "时尚企划",
    year: "2024",
    date: "2024-12-01",
    views: 22140,
    cover:
      "https://readdy.ai/api/search-image?query=High%20fashion%20editorial%20portrait%20with%20bold%20warm%20orange%20accent%20light%20and%20deep%20navy%20shadow%2C%20minimal%20studio%20setting%2C%20elegant%20magazine%20cover%20aesthetic%20high%20detail&width=1000&height=750&seq=work-cover-05&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Fashion%20editorial%20full%20body%20shot%20in%20a%20minimal%20studio%20with%20warm%20orange%20accent%20light%20and%20deep%20navy%20backdrop%2C%20premium%20magazine%20feel&width=1200&height=900&seq=work05-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20fashion%20detail%20shot%20of%20fabric%20and%20texture%20in%20warm%20orange%20light%20against%20deep%20navy%2C%20elegant%20editorial%20photography&width=1200&height=900&seq=work05-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Backstage%20fashion%20scene%20with%20softboxes%20and%20warm%20light%20streaks%2C%20deep%20navy%20tones%20with%20orange%20accent%2C%20cinematic%20editorial%20photography&width=1200&height=900&seq=work05-g3&orientation=landscape",
    ],
    summary:
      "为时尚杂志打造的封面企划，以“清醒”为主题，探索在喧嚣信息中保持自我判断的态度。",
    background: [
      "《清醒》是张津瑜受邀为时尚杂志完成的封面企划。主题来自她那段时间反复思考的一个问题：在信息过载的时代，我们如何保持独立的判断。",
      "视觉团队用大量对比强烈的光影，营造出“在强光与阴影之间保持平衡”的隐喻。造型上则回归极简，去繁就简，呼应主题。",
      "该期刊物上线后迅速售罄，企划中的主视觉也被多家媒体转载，成为当年讨论度最高的封面之一。",
    ],
  },
  {
    id: "w006",
    title: "生活影像集《日常》",
    type: "视觉大片",
    year: "2024",
    date: "2024-07-22",
    views: 13420,
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20lifestyle%20photography%20of%20a%20cozy%20morning%20desk%20with%20coffee%20and%20notebook%20in%20warm%20natural%20light%2C%20muted%20neutral%20tones%20with%20navy%20and%20orange%20accents%2C%20calm%20editorial%20composition&width=1000&height=750&seq=work-cover-06&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Warm%20morning%20window%20light%20falling%20on%20a%20simple%20wooden%20desk%2C%20muted%20neutral%20and%20navy%20tones%2C%20calm%20lifestyle%20editorial%20photography%20high%20detail&width=1200&height=900&seq=work06-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20fresh%20flowers%20and%20a%20cup%20of%20tea%20in%20soft%20warm%20light%2C%20neutral%20minimal%20lifestyle%20photography%20with%20navy%20accents&width=1200&height=900&seq=work06-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Quiet%20afternoon%20living%20room%20scene%20with%20warm%20sunlight%20and%20soft%20neutral%20textiles%2C%20navy%20and%20orange%20accents%2C%20calm%20editorial%20photography&width=1200&height=900&seq=work06-g3&orientation=landscape",
    ],
    summary:
      "一组关于“普通的一天”的影像记录，张津瑜用镜头提醒自己：值得珍藏的往往不是高光时刻。",
    background: [
      "《日常》的出发点是张津瑜的一个小小反省：在追逐“重要时刻”的过程中，她错过了太多普通的早晨。",
      "于是她用一整年时间，每天拍一张照片，记录下喝咖啡、读信、晒太阳这些再平常不过的瞬间。最终从中挑选出六十张，组成这组影像集。",
      "这组作品没有宏大的叙事，却在发布后收获了大量共鸣。很多人留言说，看完之后，想好好过一过自己的生活。",
    ],
  },
  {
    id: "w007",
    title: "品牌联名视觉《相遇》",
    type: "时尚企划",
    year: "2023",
    date: "2023-10-16",
    views: 14870,
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20co%20branding%20visual%20with%20two%20interlacing%20warm%20orange%20and%20deep%20navy%20abstract%20shapes%2C%20minimal%20premium%20brand%20key%20visual%20editorial%20photography%20high%20detail&width=1000&height=750&seq=work-cover-07&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Abstract%20interlacing%20shapes%20in%20warm%20orange%20and%20deep%20navy%20on%20soft%20gray%20background%2C%20minimal%20premium%20brand%20visual%20high%20detail&width=1200&height=900&seq=work07-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Product%20photography%20of%20a%20minimal%20object%20in%20warm%20light%20with%20deep%20navy%20backdrop%2C%20clean%20premium%20editorial%20studio%20composition&width=1200&height=900&seq=work07-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20brand%20co%20branding%20materials%20in%20warm%20orange%20and%20deep%20navy%20tones%20on%20soft%20gray%20surface%2C%20elegant%20editorial%20photography&width=1200&height=900&seq=work07-g3&orientation=landscape",
    ],
    summary:
      "与设计品牌的联名视觉企划，用两种颜色的相遇，讲述“合作”这件事最动人的部分。",
    background: [
      "《相遇》是张津瑜个人品牌与一家独立设计品牌的联名企划。双方希望用视觉语言，表达“合作”的本质：不是一方吞并另一方，而是彼此成就。",
      "主视觉以两种颜色的交织为核心，橙色与深蓝在画面中既独立又融合，形成了丰富的中间层次。这一设计逻辑也贯穿了整个联名系列。",
      "联名产品上线后获得设计圈广泛好评，也让更多人看到了个人品牌在商业合作中的可能性。",
    ],
  },
  {
    id: "w008",
    title: "纪录片《一年》",
    type: "公益影像",
    year: "2022",
    date: "2022-12-30",
    views: 11060,
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20film%20still%20of%20four%20seasonal%20landscapes%20in%20a%20single%20frame%2C%20warm%20winter%20light%20and%20deep%20navy%20shadows%2C%20quiet%20reflective%20atmosphere%2C%20editorial%20photography&width=1000&height=750&seq=work-cover-08&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Warm%20winter%20landscape%20with%20soft%20light%20and%20deep%20navy%20shadows%2C%20quiet%20documentary%20film%20still%20high%20detail%20editorial%20photography&width=1200&height=900&seq=work08-g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Spring%20landscape%20with%20fresh%20greens%20and%20warm%20sunlight%2C%20calm%20documentary%20film%20still%20with%20navy%20shadow%20tones%20high%20detail&width=1200&height=900&seq=work08-g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Autumn%20landscape%20with%20warm%20orange%20foliage%20and%20soft%20light%2C%20reflective%20documentary%20film%20still%20with%20deep%20navy%20shadows&width=1200&height=900&seq=work08-g3&orientation=landscape",
    ],
    summary:
      "张津瑜的首部纪录短片，用一年的时间，记录一个普通人如何在平凡的日子里坚持自己的热爱。",
    background: [
      "《一年》是张津瑜的第一部纪录片作品，也是她第一次完整地经历“拍摄周期与生活周期重叠”的创作。",
      "她把镜头对准了一位普通的书店店主，跟随他走过春夏秋冬，记录下那些琐碎却闪光的日常。全片没有解说词，只有真实的对话与环境声。",
      "这部作品让张津瑜意识到，纪录片的价值不在于讲述多么离奇的故事，而在于让观众重新看见身边被忽略的人。也为她后来发起“微光计划”埋下了伏笔。",
    ],
  },
];

export const getWorkById = (id: string): WorkItem | undefined =>
  worksList.find((item) => item.id === id);

export const getRelatedWorks = (item: WorkItem, limit = 4): WorkItem[] => {
  const sameType = worksList.filter(
    (w) => w.id !== item.id && w.type === item.type,
  );
  const others = worksList.filter(
    (w) => w.id !== item.id && w.type !== item.type,
  );
  return [...sameType, ...others].slice(0, limit);
};